<div class="pdf-page app-aul-037-24" id="aul03724">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b> MICROORGANISM EXCLUSION (ABSOLUTE) </b>
  </p>
  <br />
  <p class="font-small">
    This Policy does not insure any loss, damage, claim, cost, expense or other
    sum directly or indirectly arising out of or relating to:
  </p>

  <p style="padding-left: 15px" class="font-small">
    mold, mildew, fungus, spores or other microorganism of any type, nature, or
    description, including but not limited to any substance whose presence poses
    an actual or potential threat to human health.
  </p>
  <br />
  <br />
  <p class="font-small">
    This Exclusion applies regardless whether there is (i) any physical loss or
    damage to insured property; (ii) any insured peril or cause, whether or not
    contributing concurrently or in any sequence; (iii) any loss of use,
    occupancy, or functionality; or (iv) any action required, including but not
    limited to repair, replacement, removal, cleanup, abatement, disposal,
    relocation, or steps taken to address medical or legal concerns
  </p>
  <p class="font-small">
    This Exclusion replaces and supersedes any provision in the Policy that
    provides insurance, in whole or in part, for these matters
  </p>
</div>
